/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gsoa_ProductCatalog_Search_Brands } from '../models/Gsoa_ProductCatalog_Search_Brands';
import type { Gsoa_ProductCatalog_Search_Countries } from '../models/Gsoa_ProductCatalog_Search_Countries';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaProductCatalogSearchService {
    /**
     * Vyhledávání v gsoa product catalog brands
     * @returns Gsoa_ProductCatalog_Search_Brands OK
     * @throws ApiError
     */
    public static getSearchBrands({
        search,
        apiVersion = 1,
        listedProductsOnly,
        actionProducts,
    }: {
        search: string,
        apiVersion?: number,
        /**
         * Filter only items active in products catalog
         */
        listedProductsOnly?: boolean,
        /**
         * Filter only items active in action offers
         */
        actionProducts?: boolean,
    }): CancelablePromise<Gsoa_ProductCatalog_Search_Brands> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/productCatalog/search/brands',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'search': search,
                'listedProductsOnly': listedProductsOnly,
                'actionProducts': actionProducts,
            },
            errors: {
                400: `Validation error.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Vyhledávání v gsoa product catalog countries
     * @returns Gsoa_ProductCatalog_Search_Countries OK
     * @throws ApiError
     */
    public static getSearchCountries({
        search,
        apiVersion = 1,
        listedProductsOnly,
        actionProducts,
    }: {
        search: string,
        apiVersion?: number,
        /**
         * Filter only items active in products catalog
         */
        listedProductsOnly?: boolean,
        /**
         * Filter only items active in action offers
         */
        actionProducts?: boolean,
    }): CancelablePromise<Gsoa_ProductCatalog_Search_Countries> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/productCatalog/search/countries',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'search': search,
                'listedProductsOnly': listedProductsOnly,
                'actionProducts': actionProducts,
            },
            errors: {
                400: `Validation error.`,
                500: `An error occurred.`,
            },
        });
    }
}
